import { AvailableQueryParams } from '../../../../../styledComponents/MaterialTable/materialTable.models';

export const RequiredQueryParams = [
  AvailableQueryParams.Order,
  AvailableQueryParams.OrderBy,
];
